// deps
import * as React from "react";

// internal-deps
import { JuspayInAppUpiResponsePayload } from "@swiggy-private/native-bridge";

// constants
import { INAPP_UPI_STATE } from "@payment-client/constants/InAppUpi";

export interface InAppUpiContextValue {
    /** method to make inapp upi bridge request */
    makeInAppUpiRequest: (
        requestState: INAPP_UPI_STATE,
    ) => Promise<JuspayInAppUpiResponsePayload["selectedAccount"] | undefined>;

    isSdkAvailableForInAppUpi: boolean;
}

const initialInAppUpiContextValue: InAppUpiContextValue = {
    makeInAppUpiRequest: () => Promise.resolve(undefined),
    isSdkAvailableForInAppUpi: false,
};

export const InAppUpiContext = React.createContext<InAppUpiContextValue>(initialInAppUpiContextValue);

if (__DEV__) {
    InAppUpiContext.displayName = "InAppUpiContext";
}
